import { patchQueryPart, addQueryPart } from "../shared/queryPartsModel";
import { apiPost } from "../shared/apiClient";
import { buildQueryPartWrite } from "../shared/queryPartPayload";

export function disablePart(partId, userId, reason) {
  return patchQueryPart(partId, { status: "disabled", remarks: reason });
}

export function enablePart(partId, userId) {
  return patchQueryPart(partId, { status: "active" });
}

// Optional fields are only included when meaningfully present — mirrors the
// exact conditional-spread payload WorkflowTaskDrawer.js built inline.
export function buildAddPartPayload(part, { userId, queryPk }) {
  return {
    ...buildQueryPartWrite(part),
    query_pk: queryPk,
  };
}

export function addPart(part, { userId, queryPk }) {
  return addQueryPart(buildAddPartPayload(part, { userId, queryPk }));
}

// Appends already-uploaded photo URLs to a live task — WorkflowTaskDrawer's
// "Add Parts" flow calls this after uploading each staged image.
export function appendTaskImages(queryPk, userId, images) {
  return apiPost(`/queryset_v2/${queryPk}/images`, { images }).then(res => res.data);
}
